import React, { useEffect, useRef, useState } from "react";
import API from "../api";
import { useNavigate, useLocation } from "react-router-dom";
import "./BonusTextScreen.css";
import BonusImg from "../assets/images/B1-CAWTC-M1-27.png";

const BonusTextScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const scrollRef = useRef(null);

    const module_id = location?.state?.module_id;

    const [paragraphs, setParagraphs] = useState([]);
    const [showFinishButton, setShowFinishButton] = useState(false);
    const [finishButtonShown, setFinishButtonShown] = useState(false);

    useEffect(() => {
        if (!module_id) return;

        API.get(`/module/getBonus/${module_id}`)
            .then((res) => setParagraphs(res.data))
            .catch((err) => console.error("Error fetching bonus:", err));
    }, [module_id]);

    const handleScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        if (!finishButtonShown && el.scrollTop + el.clientHeight >= el.scrollHeight - 15) {
            setShowFinishButton(true);
            setFinishButtonShown(true);
        }
    };

    const handleFinish = () => {
        navigate("/bonus-final", { state: { score: paragraphs[0]?.score || 0 } });
    };

    return (
        <div className="main-content3">

            {/* ⭐ Odvojeni wrapper — 2 kolone, kao u EmailNextScreen */}
            <div className="content-wrapper">

                {/* Lijevi content box */}
                <div className="email-prevare-content3">
                    <h2 className="module-title3">BONUS XP ZA PREPORUKE</h2>

                    <div
                        className="module-description3 bonus-scroll-box"
                        ref={scrollRef}
                        onScroll={handleScroll}
                    >
                        {paragraphs.map((p, i) => (
                            <p
                                key={i}
                                className="bonus-paragraph"
                                dangerouslySetInnerHTML={{ __html: p.text.replace(/\n/g, "<br/>") }}
                            />
                        ))}
                    </div>

                    <button
                        className={`next-button3 bonus-finish-btn ${showFinishButton ? "visible" : "hidden"}`}
                        onClick={handleFinish}
                    >
                        Finish
                    </button>
                </div>

                {/* Desni odvojeni media box — SADA JE VAN teksta */}
                <div className="media-container3">
                   
                       <img src={BonusImg} alt="bonus" className="media3" />
                       
                    
                </div>

            </div>
        </div>
    );
};

export default BonusTextScreen;